import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "icon-tooltip-container" }
const _hoisted_2 = {
  key: 0,
  class: "icon-tooltip"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "icon-tooltip__message text-avenir-book"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.isHovered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.isHtml)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: `<p>${$props.tooltipMessage}</p>`,
                class: "icon-tooltip__message text-avenir-book"
              }, null, 8 /* PROPS */, _hoisted_3))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.tooltipMessage), 1 /* TEXT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      onMouseover: _cache[0] || (_cache[0] = (...args) => ($options.showTooltip && $options.showTooltip(...args))),
      onMouseout: _cache[1] || (_cache[1] = (...args) => ($options.hideTooltip && $options.hideTooltip(...args))),
      onClick: _cache[2] || (_cache[2] = $event => ($event.stopPropagation()))
    }, [
      ($props.isIcomoonIcon)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass($props.iconClass)
          }, null, 2 /* CLASS */))
        : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
            key: 1,
            class: "icon-tooltip-icon",
            icon: $props.iconClass
          }, null, 8 /* PROPS */, ["icon"]))
    ], 32 /* HYDRATE_EVENTS */)
  ]))
}